<template>
  <v-container fluid>
      <v-card class="mb-3">
        <v-row>
        <span class="font-weight-bold mt-2 mx-10">EG</span>
        <v-spacer></v-spacer>
        <v-card-title class="justify-center py-0">{{ picker }}</v-card-title>
        <v-spacer></v-spacer>
        <span class="font-weight-bold mt-2 mx-10">OG</span>
        </v-row>
      </v-card>
    <v-row>
      <v-col colls="6">
        <TimeTrackerFloorTable title="EG" :floor="1"></TimeTrackerFloorTable>
      </v-col>
      <v-col colls="6">
        <TimeTrackerFloorTable title="OG" :floor="2"></TimeTrackerFloorTable>
      </v-col>
    </v-row>
    <router-view></router-view>
  </v-container>
</template>

<script>
import {debounce} from "debounce"
import {mapGetters, mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';
import TimeTrackerEnterEvent from "@/components/TimeTracker/TimeTrackerEnterEvent";
import TimeTrackerFloorTable from "@/components/TimeTracker/TimeTrackerFloorTable";


export default {
  name: 'TimeTracker',
  props: {
    subtractHeight: {type: [Number], default: 150},
    height: {type: [Number], default: window.innerHeight},
  },

  components: {
    TimeTrackerEnterEvent,
    TimeTrackerFloorTable,
  },

  computed: {
  },

  methods: {
    onResize() {
      // this.windowHeight = (window.innerHeight - this.subheight) + 'px'
      // console.log(this.$refs)
      let topHeight = 10
      if (this.$refs.RefListTop)
        topHeight = this.$refs.RefListTop.$el.clientHeight
      let footerHeight = 10
      if (this.$refs.RefListFooter)
        footerHeight = this.$refs.RefListFooter.clientHeight
      this.windowHeight = (window.innerHeight - this.subtractHeight - topHeight - footerHeight) + "px"
      // console.log('this.windowHeight', this.windowHeight)
    },

  },

  async mounted() {
    // console.log('mounted')
    window.addEventListener("resize", this.onResize)
    this.onResize()
  },

  created() {
    window.addEventListener("resize", this.onResize);

    // update the time every second
    this.interval = setInterval(() => {
      // Concise way to format time according to system locale.
      // In my case this returns "3:48:00 am"
      this.picker = Intl.DateTimeFormat(navigator.language, {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric'
      }).format()
    }, 1000)
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },

  beforeDestroy() {
    // prevent memory leak
    clearInterval(this.interval)
  },

  data() {
    return {
      windowHeight: (this.height - this.subheight) + 'px',
      picker: null,
      search: '',
      floor: null,
    }
  }
}
</script>

<style scoped lang="scss">

</style>
